export type ProfitProduct = {
  value: string;
  label: string;
  pipSize: number;
  pipValue: number;
  price: number;
  decimals: number;
  spreadPips: number;
  commissionPerLot: number;
  swapPerLot: number;
};

export const PROFIT_PRODUCTS: ProfitProduct[] = [
  { value: 'EURUSD', label: 'EUR/USD', pipSize: 0.0001, pipValue: 10, price: 1.085, decimals: 5, spreadPips: 1.0, commissionPerLot: 15, swapPerLot: 5 },
  { value: 'GBPUSD', label: 'GBP/USD', pipSize: 0.0001, pipValue: 10, price: 1.268, decimals: 5, spreadPips: 1.2, commissionPerLot: 15, swapPerLot: 6 },
  { value: 'USDJPY', label: 'USD/JPY', pipSize: 0.01, pipValue: 6.53, price: 153.2, decimals: 3, spreadPips: 0.8, commissionPerLot: 15, swapPerLot: 8 },
  { value: 'AUDUSD', label: 'AUD/USD', pipSize: 0.0001, pipValue: 10, price: 0.652, decimals: 5, spreadPips: 1.0, commissionPerLot: 15, swapPerLot: 4 },
  { value: 'USDCAD', label: 'USD/CAD', pipSize: 0.0001, pipValue: 7.31, price: 1.368, decimals: 5, spreadPips: 1.2, commissionPerLot: 15, swapPerLot: 5 },
  { value: 'USDCHF', label: 'USD/CHF', pipSize: 0.0001, pipValue: 11.05, price: 0.905, decimals: 5, spreadPips: 1.3, commissionPerLot: 15, swapPerLot: 5 },
  { value: 'NZDUSD', label: 'NZD/USD', pipSize: 0.0001, pipValue: 10, price: 0.605, decimals: 5, spreadPips: 1.4, commissionPerLot: 15, swapPerLot: 4 },
  { value: 'XAUUSD', label: 'XAU/USD', pipSize: 0.1, pipValue: 10, price: 2392.0, decimals: 2, spreadPips: 3.5, commissionPerLot: 15, swapPerLot: 20 },
];

export const PROFIT_CURRENCIES = [
  { value: 'USD', label: 'USD', rate: 1 },
  { value: 'EUR', label: 'EUR', rate: 0.92 },
  { value: 'GBP', label: 'GBP', rate: 0.79 },
  { value: 'JPY', label: 'JPY', rate: 151 },
  { value: 'VND', label: 'VND', rate: 25300 },
];

export const SPREAD_PRODUCTS = [
  { value: 'EURUSD', label: 'EUR/USD', pipValue: 10 },
  { value: 'GBPUSD', label: 'GBP/USD', pipValue: 10 },
  { value: 'USDJPY', label: 'USD/JPY', pipValue: 6.53 },
  { value: 'AUDUSD', label: 'AUD/USD', pipValue: 10 },
  { value: 'USDCAD', label: 'USD/CAD', pipValue: 7.31 },
  { value: 'USDCHF', label: 'USD/CHF', pipValue: 11.05 },
  { value: 'NZDUSD', label: 'NZD/USD', pipValue: 10 },
  { value: 'XAUUSD', label: 'XAU/USD', pipValue: 10 },
];

export const LOT_QUICK = [0.01, 0.1, 0.5, 1, 2];
export const SPREAD_QUICK = [0.5, 1.0, 1.5, 2.0, 3.0];

export type TimeframeOption = {
  value: string;
  label: string;
  months: number;
  weeks: number;
};

export const TIMEFRAME_OPTIONS: TimeframeOption[] = [
  { value: '3M', label: '3 tháng', months: 3, weeks: 13 },
  { value: '6M', label: '6 tháng', months: 6, weeks: 26 },
  { value: '1Y', label: '1 năm', months: 12, weeks: 52 },
  { value: '3Y', label: '3 năm', months: 36, weeks: 156 },
  { value: '5Y', label: '5 năm', months: 60, weeks: 260 },
];

export type ProfitBroker = {
  name: string;
  initial: string;
  regulation: string;
  color: string;
  spreadPips: number;
  commission: number;
  swap: number;
};

export const BROKERS: ProfitBroker[] = [
  {
    name: 'IC Markets',
    initial: 'IC',
    regulation: 'ASIC · CySEC · SCB',
    color: '#7c3aed',
    spreadPips: 0.1,
    commission: 7,
    swap: 5,
  },
  {
    name: 'FxPro',
    initial: 'FP',
    regulation: 'FCA · CySEC · FSA',
    color: '#10b981',
    spreadPips: 0.8,
    commission: 0,
    swap: 6,
  },
  {
    name: 'XM',
    initial: 'XM',
    regulation: 'ASIC · CySEC · FSC',
    color: '#f59e0b',
    spreadPips: 1.0,
    commission: 0,
    swap: 6,
  },
];

export const FAQ_ITEMS = [
  {
    q: 'Ba công cụ — lợi nhuận, chi phí Spread và lợi nhuận kép — nên dùng khi nào?',
    a: 'Dùng máy tính lợi nhuận khi bạn muốn ước tính kết quả của một lệnh cụ thể trước hoặc sau khi giao dịch. Dùng công cụ chi phí Spread khi muốn biết khoản chênh lệch giá sẽ ngốn bao nhiêu trong mỗi lệnh. Dùng máy tính lợi nhuận kép khi muốn hình dung vốn tăng trưởng thế nào qua nhiều kỳ với lãi được tái đầu tư.',
  },
  {
    q: 'Lợi nhuận Forex được tính như thế nào?',
    a: 'Lợi nhuận được tính dựa trên biến động giá (tính bằng Pip) nhân với giá trị mỗi Pip và khối lượng lệnh. Với lệnh Buy, lợi nhuận xuất hiện khi giá tăng; với lệnh Sell, khi giá giảm.',
  },
  {
    q: 'Spread có ảnh hưởng đến lợi nhuận ròng không?',
    a: 'Có. Spread là chênh lệch giữa giá mua và giá bán, được trừ trực tiếp vào kết quả mỗi giao dịch. Spread càng rộng thì lợi nhuận ròng càng giảm.',
  },
  {
    q: 'Chi phí Spread được tính như thế nào?',
    a: 'Chi phí Spread = Spread (tính bằng Pip) × Giá trị mỗi Pip × Khối lượng lệnh. Ví dụ Spread là 1.5 Pip, giá trị mỗi Pip là 10 USD và bạn giao dịch 1 lô, chi phí sẽ là 1.5 × 10 × 1 = 15 USD. Khoản này được trừ ngay khi bạn mở lệnh.',
  },
  {
    q: 'Khi nào nên sử dụng máy tính lợi nhuận?',
    a: 'Trước khi vào lệnh để ước tính kết quả ở nhiều mức giá, trong khi theo dõi để xem lợi nhuận thay đổi thế nào, và sau khi giao dịch để kiểm tra kết quả thực tế.',
  },
  {
    q: 'Lợi nhuận kép có phải là dự báo lợi nhuận thực tế không?',
    a: 'Không. Đây chỉ là mô phỏng toán học dựa trên các giả định bạn nhập vào, không phải cam kết hay dự báo về kết quả giao dịch trong tương lai.',
  },
  {
    q: 'Trong công thức lợi nhuận kép, r và n nghĩa là gì, khoản nạp thêm tính thế nào?',
    a: 'r là tỷ suất lợi nhuận mỗi kỳ (ví dụ 5% mỗi kỳ thì r = 0.05), n là số kỳ (số tuần hoặc số tháng). Khoản nạp thêm là số tiền bạn đều đặn thêm vào mỗi kỳ, được cộng dồn vào vốn để tiếp tục sinh lãi — vì thế lợi nhuận kép tăng nhanh hơn nhiều so với lãi đơn.',
  },
  {
    q: 'Commission và Swap có được tính vào lợi nhuận ròng không?',
    a: 'Có. Lợi nhuận ròng = Lợi nhuận gộp − Spread − Commission − Swap − phí khác. Cả ba loại chi phí này đều được trừ để ra kết quả thực tế.',
  },
];